
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { post } from 'request/request'
import { selectLocale } from 'store/localeSlice'
import './news.less'
export const News = () => {
    const [newsList, setNewsList] = useState([])
    const intl = useIntl();
    const locale= useSelector(selectLocale);
    
    useEffect(() => {
        post('snailcar/website/common/queryNews',{pageNo: 1,pageSize: 999}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setNewsList(data.resultBody.data.list)
            }
        })
    }, [])
    return <div className='news-template-wrapper'>
        <div className='news-banner-wrapper'>
            <img className='news-img' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16704646670214287.png" alt="" />
            <div className='news-banner-title'><span>{intl.formatMessage({id: 'footer.pages.news.title'})}</span></div>
        </div>
        <div className='news-list'>
            {newsList.map((item:any, index) => <div key={index} className='news-list-item' style={{cursor: !item.detail || item.detail === '' ? 'default': 'pointer'}} onClick={() => {
                if (!item.detail || item.detail === '') {return}
                window.open(`#/newsDetail/${item.newsId}`)
            }}>
                <div className='list-img'><img src={item.newsImage} alt="" /></div>
                <div className='news-item-left'>
                    <div className='title'>{item.name}</div>
                    <div className='content'>{item.des}</div>
                    {/* <div className='time'>{item.createTime ? moment(item.createTime).format('YYYY-MM-DD') : ''}</div> */}
                </div>
            </div>)}
        </div>
    </div>
}